import { COMPANY_MSB_REGISTRATION, COMPANY_NAME } from "@/content/company";

import { FAQ } from "./faqData";
import { SOCIAL_LINKS } from "./social";

const SITE_URL = "https://pawpayments.com";

const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "PawPayments",
    legalName: COMPANY_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/Images/landing/logo-white.svg`,
    identifier: {
        "@type": "PropertyValue",
        propertyID: "FINTRAC MSB Registration",
        value: COMPANY_MSB_REGISTRATION,
    },
    sameAs: [
        "https://docs.pawpayments.com",
        ...SOCIAL_LINKS.map((s) => s.href),
    ],
    contactPoint: [
        {
            "@type": "ContactPoint",
            contactType: "customer support",
            email: "support@pawpayments.com",
            availableLanguage: ["English"],
        },
        {
            "@type": "ContactPoint",
            contactType: "sales",
            email: "business@pawpayments.com",
            availableLanguage: ["English"],
        },
        {
            "@type": "ContactPoint",
            contactType: "legal",
            email: "legal@pawpayments.com",
            availableLanguage: ["English"],
        },
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "Office 150, 145 1/2 Church Street, Unit 5",
        addressLocality: "Toronto",
        addressRegion: "Ontario",
        postalCode: "M5B1Y4",
        addressCountry: "CA",
    },
};

const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "PawPayments",
    url: SITE_URL,
    publisher: { "@id": `${SITE_URL}/#organization` },
};

const softwareApplicationSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "PawPayments",
    applicationCategory: "FinanceApplication",
    operatingSystem: "Web",
    url: SITE_URL,
    description:
        "Crypto payment gateway with auto-conversion to USDT/USDC, instant payouts, fees from 0.5%, 5-minute setup.",
    featureList: [
        "Auto-conversion to USDT/USDC",
        "Card payments for US and EU customers",
        "Instant crypto payouts",
        "5-minute merchant setup",
        "AML transaction screening",
        "Multi-network support (BTC, ETH, TRON, Gram, Solana, BNB)",
    ],
    offers: {
        "@type": "Offer",
        priceCurrency: "USD",
        price: "0",
        priceSpecification: {
            "@type": "UnitPriceSpecification",
            priceType: "https://schema.org/Commission",
            price: "0.5",
            priceCurrency: "USD",
            description: "Commission rate from 0.5% per transaction for high-volume merchants",
        },
    },
};

function faqSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: {
                "@type": "Answer",
                text: item.a,
            },
        })),
    };
}

export default function JsonLd() {
    const schemas = [
        organizationSchema,
        websiteSchema,
        softwareApplicationSchema,
        faqSchema(),
    ];

    return (
        <>
            {schemas.map((schema, i) => (
                <script
                    key={i}
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
                />
            ))}
        </>
    );
}
